import React from "react"
import { Field } from "../../../ui"
const Gallery = ({ info }) => {
    return <Field info={info} field="img" imageStyle="img" carousel />
}
export default Gallery
